import { Component, inject, Input } from "@angular/core";

import { WINDOW } from "@hermes/core-app-core";
import { BannerService } from "@hermes/domains-shell-states-shell-state";

@Component({
    selector: "h-cookie-link",
    templateUrl: "./cookie-link.component.html",
    styleUrls: ["./cookie-link.component.scss"],
})
export class CookieLinkComponent {
    private bannerService = inject(BannerService);
    private window = inject<Window>(WINDOW);

    @Input()
    public link!: string;

    @Input()
    public linkLabel!: string;

    public handleCookieLinkClick(): void {
        this.bannerService.deleteCookieBanner();
        this.window.location.href = this.link;
    }
}
